<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center" >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{providername}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
         <div class="row">
          <div class="col-sm-12 mb-3 mb-xl-0" *ngFor="let item of [1,2,3,4,5,6,7,8,9]">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body" style="height: 200px;">
                <div class="skeleton-card"></div>
              </div>
            </div>
          </div>
         </div>
        </div>
    </div>

    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center" >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{providername}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row" *ngIf="providername=='patrimoine'">
            <div class="col-lg-12 mb-2" *ngFor="let item of news">
              <div class="card border-0 shadow-sm rounded-3" [routerLink]="['/newsProviderDt',item.id]">
                <div class="row g-0">
                  <a class="col-12 col-md-12 col-xl-3 col-lg-3 bg-cover rounded-2 shadow"
                   [style.backgroundImage]="'url(' + (sanitizeHtmlWithImageFix(item.description).imageSrc ? sanitizeHtmlWithImageFix(item.description).imageSrc : getLogo(item.provider)) + ')'"
                   [routerLink]="['/newsProviderDt',item.id]">
                  </a>

                  <div class="col-lg-9 col-md-12 col-12">
                    <div class="card-body">
                      <h3 class="mb-2 text-truncate-line-2">
                        <a [routerLink]="['/newsProviderDt',item.id]" class="text-dark text-decoration-none">
                          {{ item.title }}
                        </a>
                      </h3>

                      <!-- Description without Image -->
                      <div [innerHTML]="sanitizeHtmlWithImageFix(item.description).sanitizedHtml" class="text-truncate-line-3"></div>

                      <!-- Row for Provider and Date -->
                      <div class="row align-items-center g-0 mt-3">
                        <div class="col-auto">
                          <img src="{{ getFaviconUrl(item.provider) }}" class="rounded-circle avatar-xs" alt="">
                        </div>
                        <div class="col ms-2">
                          <span>{{ getSiteName(item.provider)}}</span>
                        </div>
                        <div class="col-auto">
                          <a [routerLink]="['/newsProviderDt',item.id]" class="text-muted">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                              class="bi bi-clock align-baseline" viewBox="0 0 16 16">
                              <path
                                d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                            </svg>
                            {{ item.pubDate | date }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="row" *ngIf="providername!='patrimoine'">
            <div class="col-lg-12 mb-4" *ngFor="let item of news">
              <div class="card" [routerLink]="['/newsProviderDt',item.id]">
                <div class="row">
                 <a
                 class="col-12 col-md-12 col-xl-3 col-lg-3 bg-cover rounded-2 "
                 [style.backgroundImage]="'url(' + (item.mediaUrl ? item.mediaUrl : getLogo(item.provider)) + ')'"
                 [routerLink]="['/newsProviderDt',item.id]">
                 </a>

                  <div class="col-lg-9 col-md-12 col-12">
                    <div class="card-body">
                      <h3 class="mb-2 text-truncate-line-2 ">
                        <a [routerLink]="['/newsProviderDt',item.id]" class="text-inherit">
                          {{item.title}}
                        </a>
                      </h3>
                      <!-- List inline -->
                      <ul class="mb-5 list-inline">
                       <li  class="list-inline-item ">
                         <span [innerHTML]="sanitizeHtml(item.description.substring(0,item.title.length))" class="text-truncate-line-2"></span>
                       </li>

                      </ul>
                      <!-- Row -->
                      <div class="row align-items-center g-0">
                        <div class="col-auto">
                          <img src="{{ getFaviconUrl(item.provider)}}" class="rounded-circle avatar-xs" alt="">
                        </div>
                        <div class="col ms-2">
                          <span>
                            {{ getSiteName(item.provider)}}
                          </span>

                        </div>
                        <div class="col-auto">
                          <a class=" bookmark">
                           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                           class="bi bi-clock align-baseline" viewBox="0 0 16 16">
                           <path
                             d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                           <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                           </svg>
                           {{item.pubDate | date: 'dd MMM yyyy, h:mm a'}}
                          </a>
                        </div>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
             </div>
          </div>
          <div class="row my-3" *ngIf="news.length>0">
            <div class="col-lg-12">
               <!-- disabled and active states -->
               <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item disabled">
                    <button class="page-link" (click)="previousPage()" [disabled]="pageNum === 1" >Previous</button>
                  </li>
                  <li class="page-item">
                  <button class="page-link" >
                    {{ pageNum }}
                  </button>
                 </li>
                  <li class="page-item">
                    <button class="page-link" (click)="nextPage()">Next</button>
                  </li>
                </ul>
              </nav>

            </div>
          </div>
        </div>
    </div>
    </div>


  </section>
</main>

<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
